import { render, staticRenderFns } from "./AssessmentQuestionOption.vue?vue&type=template&id=015de5c2"
import script from "./AssessmentQuestionOption.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestionOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports